export default __webpack_public_path__ + "static/media/jomolhari.06e36db7.ttf";